<ub-card [rounded]="true" [dividers]="false">
  <h3 title>{{ bookingItemOption.title }}</h3>
  <div content>

    @if (bookingItemOption.summary.bookingDates?.min) {
      <ub-label label="Date" i18n-label>
        <span text>
          {{ bookingItemOption.summary.bookingDates | easDateRange: timezone: bookingItemOption.bookingDates?.timezone }}
        </span>
      </ub-label>
    }

    @if (bookingItemOption.summary.bookingWindow?.min) {
      <ub-label label="Booking window" i18n-label>
        <span text>
          {{ bookingItemOption.summary.bookingWindow | easDateRange: timezone: bookingItemOption.bookingWindow?.timezone }}
        </span>
      </ub-label>
    }

    @if (options?.showCapacityInfo) {
      <div>
        @if (bookingItemOption.summary.openOptions) {
          <ub-label label="Booking status" text="OPEN" variant="success" i18n-label i18n-text></ub-label>
        }
        @if (!bookingItemOption.summary.openOptions) {
          <ub-label label="Booking status" text="CLOSED" i18n-label i18n-text></ub-label>
        }
        @if (bookingItemOption.summary.openOptions) {
          <ub-label label="Open options" i18n-label>
            <span text>
              {{ bookingItemOption.summary.openOptions }}
            </span>
          </ub-label>
        }
      </div>
    }

    @if (bookingItemOption.summary.price.min !== null) {
      <ub-label label="Price" i18n-label>
        <span text>{{ bookingItemOption.summary.price| easPriceRange: bookingItemOption.summary.price.currency }}</span>
      </ub-label>
    }

    @if (bookingItemOption.venue) {
      <ub-label label="Venue" i18n-label>
        <span text>{{ bookingItemOption.venue?.name}}</span>
      </ub-label>
    }

    @if (!bookingItemOption.summary.eligible) {
      <ub-label>
        <span text>
          @if (bookingItemOption.summary.eligible) {
            <span class="met" i18n>Eligible</span>
          }
          @if (!bookingItemOption.summary.eligible) {
            <span class="unmet" i18n>Not Eligible</span>
          }
        </span>
      </ub-label>
    }

    @if (bookingItemOption.eligibilityResult && !bookingItemOption.eligibilityResult?.overall) {
      <ub-label
        label="Reason" i18n-label>
        <span text [innerHtml]="bookingItemOption.eligibilityResult.reason"></span>
      </ub-label>
    }

    @if (!options?.showCapacityInfo) {
      <div>
        @if (capacityInfo$ | async; as capacityInfo) {
          <ub-label
            label="Availability" i18n-label>
            <span text [ngClass]="{'met': capacityInfo.free > 0, 'unmet': capacityInfo.free === 0}">
              {{ capacityInfo.free }}
            </span>
          </ub-label>
        }
      </div>
    }

    @if (options?.showCapacityInfo && bookingItemOption.used_capacity) {
      <div>
        <ng-container i18n>Capacity</ng-container>
        @if (bookingItemOption.used_capacity.available === -1) {
          <div i18n>
        Maximum capacity has not been specified
      </div>
        }
        @if (bookingItemOption.used_capacity.available !== -1) {
          <ul>
            <li i18n>Maximum capacity: {{ bookingItemOption.used_capacity.available }}</li>
            <li i18n>Number of availability: {{ bookingItemOption.used_capacity.free }}</li>
          </ul>
        }
        <!-- <ul *ngIf="options?.showCapacityInfo">
        <li i18n>Number of pending: {{ bookingItemOption.used_capacity.in_progress }}</li>
        <li i18n>Number of reserved: {{ bookingItemOption.used_capacity.temporary_reserved }}</li>
        <li i18n>Number of confirmed bookings: {{ bookingItemOption.used_capacity.confirmed }}</li>
        <li i18n>Number of all bookings: {{ bookingItemOption.used_capacity.all }}</li>
      </ul> -->
    </div>
  }
</div>

<div actions>
  @if (buttons) {
    <eas-buttons-list
      [buttons]="buttons"
      [disabled]="false"
    [processing]="isOperationInProgress"></eas-buttons-list>
  }
</div>
</ub-card>
